/** Centralized API endpoint definitions. All server routes in one place. */

// Auth
export const AUTH = {
  profile: 'users/profile',
  login: 'login',
  logout: 'logout',
} as const

// Org-scoped endpoints
export const ORG = {
  get: (orgId: string) => `orgs/${orgId}`,
  accounts: (orgId: string) => `orgs/${orgId}/accounts`,
  putSignS3: (orgId: string) => `orgs/${orgId}/put-sign-s3`,
  getSignS3: (orgId: string) => `orgs/${orgId}/get-sign-s3`,
} as const

// Expenses
export const EXPENSES = {
  list: (orgId: string) => `orgs/${orgId}/expenses`,
  count: (orgId: string) => `orgs/${orgId}/expensescount`,
  detail: (orgId: string, expenseId: string) =>
    `orgs/${orgId}/expenses/${expenseId}`,
} as const

// Contacts
export const CONTACTS = {
  list: (orgId: string) => `orgs/${orgId}/contacts`,
} as const
